// extracted by mini-css-extract-plugin
export default {"card":"Card_card__stv90","icone":"Card_icone__d+IbK","nome":"Card_nome__0ZFyb","texto":"Card_texto__AUG6F","botao":"Card_botao__kT-hL"};